module.exports = __webpack_public_path__ + "img/dataCount.b4d53676.png";